import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import { analyticsCtaDataObject } from '../../../helpers/adobe-analytics';

const IMAGE_WIDTH_CAP = 1200;

export class Clive extends Lit3formBlock {
  static get characterName() {
    return 'clive';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid clive-layout">
          ${this.imageHTML}
          <div class="text-column">
            <div class="text-block">
              ${this.headerText
                ? html`
                    <h1 class="header">${unsafeHTML(this.headerText)}</h1>
                  `
                : html``}
              ${this.descriptionText
                ? html`
                    <p class="description">
                      ${unsafeHTML(this.descriptionText)}
                    </p>
                  `
                : html``}
            </div>
            ${this.ctasHTML}
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get imageHTML() {
    const src = this.imageSrc;
    if (!src) {
      return html`
        <div class="image-column"><div class="image-holder"></div></div>
      `;
    }
    return html`
      <div class="image-column">
        <div class="image-holder">
          <img src=${this.imagebossUrl(src, IMAGE_WIDTH_CAP)} alt="" />
        </div>
      </div>
    `;
  }

  get ctasHTML() {
    if (!this.ctaButtons.length) return html``;
    return html`
      <div class="cta-stack">
        ${this.ctaButtons.map(
          (cta, index) => html`
            <cta-button
              cta-data=${JSON.stringify({ ...cta, fullWidth: true })}
              cta-type=${this.ctaType(cta, index)}
              .ctaAnalyticsData=${analyticsCtaDataObject(cta, this.headerText)}
            ></cta-button>
          `
        )}
      </div>
    `;
  }

  ctaType(cta, index) {
    if (cta.type === 'primary_button' || cta.type === 'Primary button') {
      return 'primary';
    }
    if (cta.type === 'secondary_button' || cta.type === 'Secondary button') {
      return 'secondary';
    }
    // Fallback for CTAs without an explicit type: first is primary, rest secondary.
    return index === 0 ? 'primary' : 'secondary';
  }

  get imageSrc() {
    return this.content.image?.src;
  }

  get ctaButtons() {
    return this.content.cta_buttons || [];
  }
}
Clive.defineElement();
